import { getNextInvolvedTask, saveTaskForm, startProcess } from '@/api/backend/workflow';
import {
  bindGupProcess,
  getGupProfile,
  getGupStartBlock,
  getGupVisit,
  getGupVisitGeneration,
  type GupVisit,
} from '@/lib/gup';
import { useAuthStore } from '@/store/auth';
import { gupRequestConfig } from './gup-errors';

const starts = new WeakMap<GupVisit, Promise<{ processInstanceId: string; taskId: string }>>();

export const startGupApplication = (visit: GupVisit) => {
  const existing = starts.get(visit);
  if (existing) return existing;
  const generation = getGupVisitGeneration();
  const start = (async () => {
    const user = useAuthStore.getState().userProfile;
    if (getGupStartBlock(visit, user) || getGupProfile(visit, user)?.id !== user.activeProfileId) {
      throw new Error('GUP profile precondition failed');
    }
    const existingProcessId = getGupVisit()?.processInstanceId;
    const processInstanceId =
      existingProcessId ??
      (
        await startProcess(
          {
            serviceDefinitionCode: visit.srv,
            serviceCode: visit.srv,
            // Every GUP status event reports where the application was started (submissionChannel).
            submissionChannel: visit.source,
          },
          gupRequestConfig,
        )
      ).id;
    if (generation !== getGupVisitGeneration()) throw new Error('GUP visit ended');
    bindGupProcess(processInstanceId);
    const nextTask = await getNextInvolvedTask(processInstanceId);
    if (generation !== getGupVisitGeneration()) throw new Error('GUP visit ended');
    // GUP source is the in-memory ref used by native starts as engagementChannelRef.
    const ref = visit.source;
    await saveTaskForm(nextTask.id, { engagementChannelRef: ref }, gupRequestConfig);
    return { processInstanceId, taskId: nextTask.id };
  })();
  starts.set(visit, start);
  return start;
};
